import { all, reactive, VArray } from 'alkali'
import { sortBy } from 'lodash'
import { evidenceSearch, selectedOutcomes, groupedInterventions } from './EvidenceSearch'
import { groupConnectivity } from 'model/GroupConnectivity'
window.groupConnectivity = groupConnectivity
import { analysisType, metaResults, currentAnalysisSelections } from './SearchQuery'
let characteristicEffects = reactive({})
export const view = reactive('bar-chart')
export let lastMedian

export const analysisResults = all([metaResults, analysisType, currentAnalysisSelections.settings,selectedOutcomes], (results, analysisType, settings) => {
	if (!results)
		return []
	lastMedian = results.median
	let { min, max } = results
	results.scale = 25 / Math.max(max, -min)
	if (settings?.reverseDirection)
		results.scale *= -1
	
	if (analysisType == 'direct' || analysisType == 'cohort' || analysisType == 'auto' && results.interventions?.length < 3)
		return view.to(view => {
			if (view == 'bar-chart'){
				results.isForestPlot = false
				return [results]
			}
			else {
				results.isForestPlot = true
				// for forest plot, put active intervention at the top
				results.interventions = sortBy(results.interventions, resultIntervention =>{
					if (resultIntervention.name == 'Control')
						return 1000
					let requestedInterventions = groupedInterventions.valueOf()
					let intervention = requestedInterventions?.find(intervention => intervention.label == resultIntervention.name)
					if (intervention)
						return requestedInterventions.indexOf(intervention)
					return 100
				})
				return [results]
			}
		})
	results.isForestPlot = false
	return [results] // in network modes, results are shown as groups
}).as(VArray)

import { metaAnalysisResults } from './MetaAnalysis'

const roundingNumber = x => Math.pow(10, Math.floor(Math.log10(Math.max(Math.abs(x), 0.0001))))

